import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { CustomFieldBuilder } from "../../../containers/utilities/CustomFieldBuilder";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import {getWizardContentDescription} from "../../../utilities/WizardContentUtil";

interface WizardContentProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    itemId?: string;
    supportedFields?: any[];
}

export const WizardContent: FC<WizardContentProps> = ({ onBack = undefined, onNext = undefined, itemId = undefined, supportedFields = undefined }) => {
    const nameAccessor = 'name';
    const formik = useFormikContext();
    const [hasError, setHasError] = useState(false);
    const { translate } = useLocale();
    const customFieldBuilder: CustomFieldBuilder = new CustomFieldBuilder(formik, translate);

    useEffect(() => {
        formik.validateForm();
    }, [(formik.values as any).custom])

    useEffect(() => {
        // get supported field system name that is used as accessors
        const supportedFieldAccessors = supportedFields?.map(field => field.systemName) ?? new Array(0);

        // for the first page, the name is required.
        if (formik.errors[nameAccessor]
            // for the second page, any supported field errors should block it.
            || (supportedFieldAccessors.length > 0 && Object.keys(formik.errors as any).length > 0)) {
            setHasError(true)
        }
        else {
            setHasError(false)
        }
    }, [formik.errors])

    const handleNext = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (onNext && (itemId)) {
            if (!hasError) {
                const detailDescription = getWizardContentDescription(formik.values, supportedFields);
                formik.validateForm().then(() => onNext({ ...e, itemName: detailDescription.detailDescription,
                    presetItem: formik.values, toolTipDescription: detailDescription.tooltipDescription,
                    showToolTip: detailDescription.showToolTip }));
            }
        }
    }

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            {supportedFields?.reduce((formFields, field) =>
                customFieldBuilder.buildFormField(formFields, field, false, true, undefined),
                new Array(0))
                .map(fieldBundle =>
                    fieldBundle.map(field => field.content)
                )}
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary  ${hasError || !(itemId) ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'}`}
                    type='button'
                    onClick={handleNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>;
};
